module.exports = __webpack_public_path__ + "static/img/icons8-heart.1cb0965e.svg";